import { render, staticRenderFns } from "./UnstarItemIcon.vue?vue&type=template&id=976948ac&scoped=true"
import script from "./UnstarItemIcon.vue?vue&type=script&lang=js"
export * from "./UnstarItemIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "976948ac",
  null
  
)

export default component.exports